var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1674)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2975 -0.000976562C16.8769 -0.000976562 17.446 0.23431 17.8563 0.644609L22.1431 4.93138C22.5593 5.34755 22.7887 5.90195 22.7887 6.4902V24.999H2.20044V-0.000976562H16.2975ZM15.4357 1.46961H3.67101V23.5285H21.3181V7.35197H15.4357V1.4696L15.4357 1.46961ZM16.9063 1.77402V5.88138H21.0137L16.9063 1.77402Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7252 8.82324C12.0737 8.82324 12.3811 8.98796 12.6105 9.31589C13.1561 10.085 13.1179 10.9041 12.9164 12.0071C12.8473 12.3865 12.9179 12.7703 13.1281 13.0894C13.4252 13.5424 13.8531 14.1659 14.2737 14.6938C14.5826 15.0835 15.0576 15.2909 15.5384 15.2262C15.8473 15.1835 16.2193 15.1482 16.6017 15.1482C18.3076 15.1482 18.1796 15.7571 18.334 16.3159C18.4193 16.6541 18.3767 16.9497 18.2017 17.1688C17.984 17.4644 17.5355 17.6174 16.8796 17.6174C16.1531 17.6174 15.9134 17.4938 15.2811 17.2924C14.9237 17.1776 14.5531 17.1541 14.1914 17.2497C13.4693 17.4379 12.2781 17.7247 11.284 17.8615C10.7531 17.935 10.2708 18.2085 9.9502 18.6541C9.22814 19.6541 8.55903 20.5879 7.49873 20.5879C7.2252 20.5879 6.97373 20.4894 6.76638 20.2924C6.4605 19.9865 6.32961 19.6468 6.39433 19.2526C6.57373 18.0424 8.06197 17.3674 8.94727 16.8747C9.15608 16.7585 9.3208 16.5806 9.42373 16.36L10.8282 13.3232C10.9282 13.11 10.959 12.8732 10.9223 12.6394C10.759 11.61 10.5178 9.87913 11.1664 9.09677C11.309 8.92177 11.5061 8.82324 11.7252 8.82324ZM11.9929 13.2497C11.4296 14.8982 10.434 16.6909 10.3002 16.8997C11.5017 16.335 13.8929 16.0497 13.8929 16.0497C12.6899 14.8909 11.9929 13.2497 11.9929 13.2497Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0 0.000305176)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf Icon.81a99f00d76770cc7b819a30b149cbf5.svg";
export { ForwardRef as ReactComponent };